import React from 'react'

function CheckboxUnchecked(props) {
  return (
    <svg id="icon" width="32" height="32" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <title>checkbox</title>
      <path d="M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"/>
      <rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" fill="none" width="32"
            height="32"/>
    </svg>
  )
}

export default CheckboxUnchecked
